import React, { useEffect } from 'react';
//animeJs
import anime from 'animejs';

const SVG = ({
  fill = '#fff',
  width = '100%',
  height = '100%',
  className = 'waveSVG',
}) => {
  useEffect(() => {
    let animation = anime.timeline({
      easing: 'easeOutExpo',
      duration: 350,
    });
    // Add children
    animation
      .add(
        {
          targets: '.waveSVG path',
          scale: 1.1,
          fill: '#f98664',
        },
        2000
      )
      .add({
        targets: '.waveSVG path',
        scale: 1,
        fill: '#7370a3',
      });
  }, []);

  const onHoverOn = e => {
    anime({
      targets: '.waveSVG path',
      scale: 1.1,
      fill: '#f98664',
    });
  };
  const onHoverOut = e => {
    anime({
      targets: '.waveSVG path',
      scale: 1,
      fill: '#7370a3',
    });
  };

  return (
    <svg
      viewBox="0 0 288 134"
      height={height}
      width={width}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={onHoverOn}
      onMouseLeave={onHoverOut}
    >
      <path
        d="M247.2,31.2c-12.9,0.9-14.4,13.2-28.5,13.2c-14.6,0-14.6-13.2-30-13.2s-15.4,13.2-30,13.2c-14.6,0-15.4-13.2-30-13.2
	s-15.4,13.2-30,13.2c-12.2,0-16-13.2-30-13.2c-15,0-15,13.2-29.6,13.2c0.1,1.3-0.3,6.1-0.2,7.4l0,0c14.6,0,14.6-13.2,29.6-13.2
	c14,0,17.8,13.2,30,13.2c14.6,0,15.4-13.2,30-13.2c14.6,0,15.4,13.2,30,13.2s14.6-13.2,30-13.2c15.4,0,15.4,13.2,30,13.2
	c14.2,0,15.7-12.4,28.7-13.2V31.2z"
      />
      <path
        d="M247.2,47.7c-12.9,0.9-14.4,13.2-28.5,13.2c-14.6,0-14.6-13.2-30-13.2s-15.4,13.2-30,13.2c-14.6,0-15.4-13.2-30-13.2
	s-15.4,13.2-30,13.2c-12.2,0-16-13.2-30-13.2c-15,0-15,13.2-29.6,13.2c0.1,1.3-0.3,6.1-0.2,7.4l0,0C53.5,68.3,53.5,55,68.5,55
	c14,0,17.8,13.2,30,13.2c14.6,0,15.4-13.2,30-13.2c14.6,0,15.4,13.2,30,13.2s14.6-13.2,30-13.2c15.4,0,15.4,13.2,30,13.2
	c14.2,0,15.7-12.4,28.7-13.2V47.7z"
      />
      <path
        d="M247.2,64.9C234.3,65.8,232.8,78,218.7,78c-14.6,0-14.6-13.2-30-13.2S173.3,78,158.7,78c-14.6,0-15.4-13.2-30-13.2
	S113.3,78,98.7,78c-12.2,0-16-13.2-30-13.2c-15,0-15,13.2-29.6,13.2c0.1,1.3-0.3,6.1-0.2,7.4l0,0c14.6,0,14.6-13.2,29.6-13.2
	c14,0,17.8,13.2,30,13.2c14.6,0,15.4-13.2,30-13.2c14.6,0,15.4,13.2,30,13.2s14.6-13.2,30-13.2c15.4,0,15.4,13.2,30,13.2
	c14.2,0,15.7-12.4,28.7-13.2V64.9z"
      />
      <path
        d="M248.2,80.5c-12.9,0.9-14.4,13.2-28.5,13.2c-14.6,0-14.6-13.2-30-13.2s-15.4,13.2-30,13.2c-14.6,0-15.4-13.2-30-13.2
	s-15.4,13.2-30,13.2c-12.2,0-16-13.2-30-13.2c-15,0-15,13.2-29.6,13.2c0.1,1.3-0.3,6.1-0.2,7.4l0,0c14.6,0,14.6-13.2,29.6-13.2
	c14,0,17.8,13.2,30,13.2c14.6,0,15.4-13.2,30-13.2c14.6,0,15.4,13.2,30,13.2s14.6-13.2,30-13.2c15.4,0,15.4,13.2,30,13.2
	c14.2,0,15.7-12.4,28.7-13.2V80.5z"
      />
    </svg>
  );
};

export default SVG;
